
/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';

// Context
import AuthContext from '../../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import {
  getInvoiceWithIdAction,
  getInvoicesLogs,
} from '../saga/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLogs,
  makeSelectLoading,
  makeSelectError,
  makeSelectInvoicesList,
} from '../saga/selectors';


//UI
import theme from '../../../theme';
import {
  Typography,
  Paper,
  Grid,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
} from '@material-ui/core';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Components
import Can from '../../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../../utils/rulesOrderStatus';

// Helper
import { numberWithCommas, translate } from '../../../utils/helpers';
import jMoment from 'moment-jalaali';
import downloadInvoiceFile from 'client-sdk/src/invoices/download'
import classes from '../style/details.module.scss';
import { Link } from 'react-router-dom';
import RonadIcons from '../../../components/iconComponent';

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته‌بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  CREATED: 'document',
  PAID: 'check',
  NOT_PAID: 'creditCard',
  CANCELED: "times"
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  useEffect(() => {
    const { id } = props.match.params;
    props.invoiceDispatch({
      id,
      page: 0,
      size: 1000,
    });
    props.logDispatch({
      id,
      page: 0,
      size: 1000,
    });
  }, [props.match.params]);

  const downloadInvoiceFiles = (type: string) => {
    downloadInvoiceFile(props.invoice.id, type)
      .then(response => response.blob())
      .then(myBlob => {
        downloadFile(myBlob, type == "RECEIPT" ? props.invoice.fileName : props.invoice.detailFileName);
      });
  };

  const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
  };
  return (
    <div className={classes.root}>
      {/* <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
        جزيیات مالی
        <span data-cy="orderIdHead"> &nbsp; {props.match.params.id}</span>
      </Typography>

      <Grid
        container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px' }}
      >
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات صورتحساب
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت:  '}</span>
                  <Can
                    role={authContext.user.role}
                    perform="orders:changeOrderStatus"
                    yes={() => (
                      <FormControl style={{ width: '50%' }}>
                        <RonadIcons name='pencil' className={classes.changStatusIcon}/>
                        <Select
                          className={classes.changStatusBox}
                          fullWidth
                          inputProps={{
                            name: 'name',
                            id: 'uncontrolled-native',
                          }}
                          name={'status'}
                          id={props.invoice.id}
                          value={[{}]}
                          IconComponent={() => null}
                          renderValue={() => (
                            <span className={classes.renderValue}>
                              {console.log(props.invoice.status)}
                              {translate(props.invoice.status, 'invoice')}
                            </span>
                          )}
                        >
                          <RadioGroup
                            className={classes.radioGroup}
                            aria-label={'status'}
                            name={'status$'}
                            value={'item'}
                            onChange={(
                              e: React.ChangeEvent<{ value: unknown }>
                            ) =>
                              handleOpenConfirmUpdateState(
                                `"${e.target.value}"` as Status
                              )
                            }
                          >
                            {rulesOrderStatus[props.order.status]?.map(
                              (item: any, index: number) => (
                                <FormControlLabel
                                  className={classes.radioGroupItem}
                                  key={index}
                                  checked={props.order.status === item}
                                  value={item}
                                  disabled={
                                    rulesAdminChangeOrderStatus[
                                      authContext.user.role
                                    ].indexOf(item) === -1
                                  }
                                  control={<Radio />}
                                // label={translate(item, 'order')}
                                />
                              )
                            )}
                          </RadioGroup>
                        </Select>
                      </FormControl>
                    )}
                    no={() => (
                      <span style={{ textAlign: 'left' }} data-cy="status">
                        {translate(props.invoice.status, 'invoice')}
                      </span>
                    )}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شرکت :  '}</span>

                  <span>{props.invoice.partnerName}</span>
                </div>
              </Grid>
              {props.order?.paymentType === 'COD' && (
                <Grid item xs={12} sm={12} lg={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'شناسه:  '}</span>

                    <span>{props.invoice.id}</span>
                  </div>
                </Grid>
              )}

              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' تاریخ ایجاد:  '}</span>
                  <span data-cy="registrationDate">
                    {props.invoice.created &&
                      `${jMoment(props.invoice.created, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'مبلغ فاکتور (ریال):  '}</span>
                  <span data-cy="trackingCode">{numberWithCommas(props.invoice.amount)}</span>
                </div>
              </Grid>
              {!!props.invoice.insuranceCost && <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'سپرده بیمه (ریال):  '}</span>
                  <span data-cy="trackingCode">{numberWithCommas(props.invoice.insuranceCost)}</span>
                </div>
              </Grid>}
              {!!props.invoice.damageCost && <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'خسارت (ریال):  '}</span>
                  <span data-cy="trackingCode">{numberWithCommas(props.invoice.damageCost)}</span>
                </div>
              </Grid>}
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'مبلغ قابل پرداخت (ریال):  '}</span>
                  <span data-cy="trackingCode">{numberWithCommas(props.invoice.amount - props.invoice.insuranceCost - props.invoice.damageCost)}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'بابت:  '}</span>
                  <span data-cy="deliveryType">{decodeURI(props.invoice.subject)}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره کارت:  '}</span>
                  <span data-cy="deliveryType">{props.invoice.cardNumber}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره تراکنش:  '}</span>
                  <span data-cy="deliveryType">{props.invoice.trackId}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شناسه مرجع:  '}</span>
                  <span data-cy="deliveryType">{props.invoice.refNumber}</span>
                </div>
              </Grid>
              <Divider style={{ width: '100%', margin: '16px 0' }} />
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'فایل فاکتور:  '}</span>
                  <a href="#" onClick={() => downloadInvoiceFiles("RECEIPT")}>
                    {props.invoice.fileName}
                  </a>
                </div>
              </Grid>
              {props.invoice.detailFileName && <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'فایل جزئیات فاکتور:  '}</span>
                  <a href="#" onClick={() => downloadInvoiceFiles("DETAIL")}>
                    {props.invoice.detailFileName}
                  </a>
                </div>
              </Grid>}
              {/* <Link to={`/pay-process/${props.match.params.id}`}>
                <Button fullWidth color='primary' variant='contained'>پرداخت</Button>
              </Link> */}
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2}>
          <Card className={classes.card} style={{ marginTop: '24px' }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه صورت حساب
                </Typography>
              }
            />
            <CardContent style={{ padding: '0', marginTop: '-10px' }}>
              <Grid container style={{ padding: '0' }}>
                <Grid item xs={12}>
                  <Timeline align="left" style={{ minWidth: '500px' }}>
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy="timeLineItem"
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : '',
                              }}
                            >
                              <RonadIcons name={iconStatus[log.newStatus] || "circleMedium"} className='text-white'/>
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: '10px' }}>
                              <div className={classes.contentBox}>
                                <div style={{ flex: 2, textAlign: 'right' }}>
                                  <span className={classes.contentlabel}>
                                    وضعیت صورتحساب:
                                  </span>
                                  <span data-cy="status">
                                    {translate(log.newStatus, 'invoice')}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: 'right',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>

                                  <span>{log.modifierName}</span>
                                  <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>

                                  <span data-cy="role">
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                </div>
                                <Typography
                                  component="div"
                                  className={classes.titleBox}
                                  style={{ flex: 1 }}
                                >
                                  {log.time &&
                                    jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                      .locale('fa')
                                      .format('jYYYY/jMM/jDD - HH:mm')}
                                </Typography>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  invoice: makeSelectInvoicesList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    invoiceDispatch: (payload: Object) =>
      dispatch(getInvoiceWithIdAction(payload)),
    logDispatch: (payload: Object) => dispatch(getInvoicesLogs(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
